import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'

interface AdminToolParams {
    Guid: string
}

const baseUrl = `${getBaseUrl()}/API/v3/Account`
export const adminApi = createApi({
    reducerPath: 'adminApi',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        getAdminProcedure: builder.query<any, void>({
            query: () => ({
                url: '/AdminTools',
                method: 'POST',
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),
        refreshToken: builder.query<any, void>({
            query: () => ({
                url: '/token/refresh', // Endpoint specific to refresh token
                method: 'GET', // Since you're using 'type: "Get"'
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                },
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),

        // Run Admin Tool Procedure
        RunAdminProcedure: builder.mutation<any, AdminToolParams>({
            query: (guid) => {
                const params = new URLSearchParams()
                params.append('Guid', guid.Guid)
                return {
                    url: '/AdminTools',
                    method: 'PUT',
                    body: params.toString(),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    },
                }
            },
            transformResponse: (response: any) => {
                return response.data.AdminTool
            },
        }),

        PerformSignOut: builder.mutation<any, void>({
            query: () => ({
              url: "SignOut",
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
              },
            }),
            transformResponse: (response: any) => {
                return response.data ? response.data : []
            },
        }),
        RunAdminTools: builder.mutation<any, any>({
            query: (request) => {
                const params = new URLSearchParams()
                //FP-10017 Need to modify request data according to API Dto's format for the API to work correctly
                Object.keys(request.AdminTool).forEach((key) => {
                    let value = request.AdminTool[key]
                    if (typeof value === 'string' && value.startsWith('@')) {
                        value = value.substring(1)
                    }
                    if (
                        key !== 'ParamList' &&
                        value !== null &&
                        value !== undefined &&
                        value !== ''
                    ) {
                        params.append(`AdminTool[${key}]`, value)
                    }
                })

                if (request.AdminTool && request.AdminTool.ParamList) {
                    request.AdminTool.ParamList.forEach((param: any, index: number) => {
                        Object.keys(param).forEach((paramKey) => {
                            let paramValue = param[paramKey]
                            if (typeof paramValue === 'string' && paramValue.startsWith('@')) {
                                paramValue = paramValue.substring(1)
                            }
                            if (paramKey === 'IsNull') {
                                paramValue = paramValue ? 'true' : 'false'
                            }
                            if (
                                paramValue !== null &&
                                paramValue !== undefined &&
                                paramValue !== ''
                            ) {
                                params.append(
                                    `AdminTool[ParamList][${index}][${paramKey}]`,
                                    paramValue
                                )
                            }
                        })
                    })
                }

                return {
                    url: '/RunAdminTool',
                    method: 'POST',
                    body: params.toString(),
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    },
                }
            },
            transformResponse: (response: any) => {
                return response.data
            },
        }),
    }),
})

export const { useGetAdminProcedureQuery, useRunAdminProcedureMutation, useRunAdminToolsMutation, useRefreshTokenQuery, usePerformSignOutMutation } =
    adminApi
